/* eslint-disable react-hooks/exhaustive-deps */
import {useCallback, useEffect, useState} from "react";

function useDragToScrollAssetList(scrollRef) {
  const [containerEl, setContainerEl] = useState(scrollRef.current);
  const [isDragging, setIsDragging] = useState(false);
  const [startPosition, setStartPosition] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const handleMouseDown = useCallback(
    e => {
      setIsDragging(true);
      setStartPosition(e.pageX - containerEl.offsetLeft);
      setScrollLeft(containerEl.scrollLeft);
    },
    [containerEl, isDragging, scrollLeft, startPosition],
  );

  const handleMouseUp = useCallback(() => {
    setIsDragging(false);
  }, [containerEl, isDragging, scrollLeft, startPosition]);

  const handleMouseLeave = useCallback(() => {
    setIsDragging(false);
  }, [containerEl, isDragging, scrollLeft, startPosition]);

  const handleMouseMove = useCallback(
    e => {
      if (!isDragging) return;
      e.preventDefault();
      const x = e.pageX - containerEl.offsetLeft;
      const walk = (x - startPosition) * 2;
      containerEl.scrollLeft = scrollLeft - walk;
    },
    [containerEl, isDragging, scrollLeft, startPosition],
  );

  useEffect(() => {
    if (!containerEl) {
      setContainerEl(scrollRef.current);
      return;
    }
    containerEl.addEventListener("mousedown", handleMouseDown);
    containerEl.addEventListener("mouseup", handleMouseUp);
    containerEl.addEventListener("mousemove", handleMouseMove);
    containerEl.addEventListener("mouseleave", handleMouseLeave);

    return () => {
      containerEl.removeEventListener("mousedown", handleMouseDown);
      containerEl.removeEventListener("mouseup", handleMouseUp);
      containerEl.removeEventListener("mousemove", handleMouseMove);
      containerEl.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, [scrollRef, containerEl, handleMouseDown, handleMouseUp, handleMouseMove]);

  return {scrollRef};
}

export default useDragToScrollAssetList;
